import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSocket } from '../contexts/SocketContext';
import { useToast } from '../hooks/useToast';
import { Select, Slider, TagInput } from './ui';

const INTERESTS = [
  'Gaming', 'Movies', 'Music', 'Sports', 'Travel',
  'Cooking', 'Reading', 'Art', 'Technology', 'Fitness',
  'Photography', 'Dancing', 'Writing', 'Fashion', 'Science'
];

const GENDERS = [
  { value: 'any', label: 'Any' },
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' }
];

const PreferencesForm = () => {
  const [preferences, setPreferences] = useState({
    gender: 'any',
    minAge: 18,
    maxAge: 99,
    interests: []
  });
  const navigate = useNavigate();
  const { socket } = useSocket();
  const { showToast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    socket.emit('set-preferences', preferences);
    navigate('/');
    showToast('Preferences saved!', 'success');
  };

  const handleGenderChange = (e) => {
    setPreferences(prev => ({
      ...prev,
      gender: e.target.value
    }));
  };

  const handleAgeChange = (values) => {
    setPreferences(prev => ({
      ...prev,
      minAge: values[0],
      maxAge: values[1]
    }));
  };

  const handleInterestsChange = (interests) => {
    setPreferences(prev => ({
      ...prev,
      interests
    }));
  };

  return (
    <div className="preferences-form">
      <h2>Set Your Preferences</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="gender">Gender Preference:</label>
          <Select
            id="gender"
            value={preferences.gender}
            onChange={handleGenderChange}
            options={GENDERS}
            placeholder="Select gender preference"
          />
        </div>

        <div className="form-group">
          <label>Age Range:</label>
          <Slider
            min={18}
            max={99}
            value={[preferences.minAge, preferences.maxAge]}
            onChange={handleAgeChange}
          />
        </div>

        <div className="form-group">
          <label>Interests</label>
          <TagInput
            value={preferences.interests}
            onChange={handleInterestsChange}
            suggestions={INTERESTS}
            placeholder="Select interests..."
            maxTags={5}
          />
          <small className="text-muted">
            Select up to 5 interests to find better matches
          </small>
        </div>

        <button type="submit" className="save-button">
          Save Preferences
        </button>
      </form>
    </div>
  );
};

export default PreferencesForm; 